import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
//Material imports
import { withStyles } from "@material-ui/core/styles"; //Limitless imports

import SlideImage from "../slide-image/SlideImage";
import SlideBody from "../slide-body/SlideBody";
import SlideTitle from "../slide-title/SlideTitle";
import SlideCloseIcon from "../slide-close-icon/SlideCloseIcon";

var ImageTitleBody = function ImageTitleBody(_ref) {
  var classes = _ref.classes,
      slide = _ref.slide,
      shouldAnimate = _ref.shouldAnimate,
      rest = _objectWithoutProperties(_ref, ["classes", "slide", "shouldAnimate"]);

  var imgSrc = slide.imgSrc,
      headline = slide.headline,
      headlineColor = slide.headlineColor;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.imageTitleBodyContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.imageContainer
  }, /*#__PURE__*/React.createElement(SlideImage, {
    imgSrc: imgSrc,
    primaryColour: "unset",
    shouldAnimate: shouldAnimate
  }), /*#__PURE__*/React.createElement(SlideCloseIcon, Object.assign({
    slide: slide
  }, rest))), /*#__PURE__*/React.createElement("div", {
    className: classes.textContainer
  }, /*#__PURE__*/React.createElement(SlideTitle, {
    slide: slide,
    gutterBottom: false,
    style: {
      backgroundColor: "unset"
    }
  }), /*#__PURE__*/React.createElement(SlideBody, {
    headline: headline,
    shouldAnimate: shouldAnimate,
    color: headlineColor
  })));
};

var styles = {
  imageTitleBodyContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    justifyContent: "center"
  },
  imageContainer: {
    position: "relative",
    margin: "0px auto",
    overflowY: "hidden",
    width: 320,
    height: 290 // this was added to stop an image load flicker

  },
  "@media screen and (min-width: 450px)": {
    imageContainer: {
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
      margin: "0px auto",
      overflowY: "hidden"
    }
  },
  textContainer: {
    display: "flex",
    justifyContent: "space-around",
    flexDirection: "column",
    flex: 1,
    maxHeight: 150
  }
};
export default withStyles(styles)(ImageTitleBody);